export const REST_URL = {
  API: '/api',
  BASE_APIM: '/ms-uptime-base',
  AUDIT_APIM: '/ms-audit/api',
  PROVISIONING_APIM: '/ms-provisioning',
  CONFIG_APIM: '/ms-config/api',
  KNOWLEDGE: '/knowledge',
  LINK_LIBRARY: '/appdb/getURLs',
  GET_SETTINGS: '/appdb/getVariables',
  SEARCH: '/search',
  FILTER_CATEGORY: '/filterCategory',
  RETRIEVE: '/retrieve',
  LAST_COMMENT: '/latestComment',
  ANNOUNCEMENT: '/announcements',
  ATTACHMENT: '/attachment',
  ALL_ATTACHMENT: '/attachments',
  DOWNLOAD_ATTACHMENT: '/downloadAttachment',
  FEEDBACK: '/provideFeedback',
  FEEDBACK_TASK: '/feedback-task',
  FEEDBACK_UPLOAD_ATTACHMENT: '/feedbackUploadAttachment',
  KB_RATINGS: '/ratings',
  KB_USEFULS: '/usefuls',
  KB_COMMENTS: '/comments',
  KB_COMMENT: '/comment',
  LIKE_COMMENT: '/likeComment',
  UNLIKE_COMMENT: '/unlikeComment',
  DELETE_COMMENT: '/deleteComment',
  RETRIEVE_USEFUL: '/retrieveUsefulPercentage',
  SUPPORTTICKET: '/supportRequests',
  GET_ALL: '/getAll',
  INCIDENT: '/incident',
  REQUEST: '/request',
  ORDER: '/order',
  APPROVAL: '/request-approval',
  APPROVE: '/approve',
  REJECT: '/reject',
  RETRIEVEBYNUMBER: '/retrieveByNumber',
  RETRIEVE_REQUEST_BYNUMBER: '/retrieveRequestItemByNumber',
  REQUEST_ITEM: '/requestItem',
  ADD_COMMENT: '/addComment',
  UPDATE_TICKET: '/update',
  CMDB: '/cmdb',
  SHIPPING: '/shipping',
  USERINFO: '/userInfo',
  GET_USER_DEVICES: '/getUserDevices',
  GET_ASSET_HARDWARES: '/getAssetHardwares',
  GET_WHATSNEW: '/retrieveWhatsnew',
  GET_MARKET_PLACES: '/appdb/getMarketplaces',
  GET_MARKET_PLACE_DETAIL: '/appdb/getMarketplaceDetail',
  RETRIEVE_TOP_VIEW_BY_CATE: '/retrieveTopViewByCate',
  M365: '/m365',
  GET_MY_OFFICE_LINKS: '/getMyOfficeLinks',
  USER_SEARCH: '/userSearch',
  ORDERS_METADATA: '/orders/metadata',

  MY_ASSETS: '/getMyAssets',
  GET_ASSET_BY_ID: '/getAsset',
  ELIGIBLE_REFRESH_ASSETS: '/eligibleDevices',
  GET_MY_NEW_DEVICE_ASSET_REQUESTS : '/getMyNewDeviceAssetRequests',
  DEVICE_FORM: '/getQuestions',
  GET_ALL_FEATURE: '/featured',
  NEWS: '/news',
  SUBMIT_DEVICE_REQUEST_FORM: '/proceedcatalogItem',
  CHECK_PILOT_USER: '/checkPilotUser',
  ADDRESS_VALIDATION: '/addressValidation',
  ADDRESS_FIELDS: '/addressFields',

  VIEW_COUNT: 'viewCount',
  CACHE: '/cache',
  CLEAR_POLICY: '/clearPolicy',

  GET_ALL_BAD_WORDS: '/',
  GET_SECRET_KEY_CONFIG: '/getPwdConfiguration',

  GET_FILTERS: '/getFilters',
  CHECK_USER_PILOT_MODE: '/checkPilotModeUser',
  ACTIVITIES: '/activities',
  RESOLVED: '/resolved',
  GET_ATTACHMENTS: '/getAttachments',
  POST_ATTACHMENT: '/uploadAttachment',
  POST_INCIDENT_REOPEN: '/reopen',
  GET_INCIDENT_NUMBER: '/getByNumber',
  DELETE_ATTACHMENT: '/deleteAttachment',
  DXC_GEAR: '/user/checkUserDxcGear',
  PC_LIFECYCLE_REQUEST: '/pcl-requests',
  PC_LIFECYCLE_CANCEL_REQUEST: '/pcl-requests/cancel',
  GET_TENANT_CONFIG: '/getTenant',
  CLEAR_ORDER: '/clearOrder',
  ASSET: '/asset',
  GET_BY_SERIAL_NUMBER: '/getBySerialNumber',
  GET_CONFIG: '/getConfig',
  CLEAR_ALL_BY_USER: '/clearAllByUser',
  GET_REFERENCES: '/getUserPreferences',
  UPSERT_REFERENCES: '/upsertUserPreferences',
  CHECK_ASSIGNED_DEVICE: '/checkAssignedDevice',
  AVAILABLE_DEVICE_MODEL: '/availableDeviceModel',
  SAVE_AUDIT_LOG: '/audit/create',
  SAVE_DELEGATION: '/saveDelegation',
  GET_DELEGATION: '/getDelegation',
  AUDIT: '/audit',
  CREATE: '/create',
  CHECK_CANCEL: '/checkCancel',
  SEND_EMAIL: '/sendMail',
  GET_MY_OWN_TEAMS: '/getMyOwnTeams',
  CHECK_USER_IS_IN_GROUP: '/checkUserIsInGroup',
  GET_OPEN_SUPPORT_ACTIVITIES: '/getOpenSupportActivities',
  GET_PICKUP_DEPOT: '/getPickupDepot',
  CATALOG: '/catalog',
  CREATE_BOOMI_REQUEST: '/createBoomiRequest',
  UPTIME_LOG: '/uptimelog/insert',
  GET_DEVICES_BY_MANAGER: "/asset/getDevicesByManager",
  IS_USER_IN_GROUP: '/isUserInGroup',
  NOTIFICATION: "/notification",
  NOTI_SEND: "/send",
  DEVICE_MANAGEMENT: "/device-management",
  METRICS_HISTORY: "/metrics-history-by-fqdn",
  CONFIG_API: '/ms-config/api',
  CONFIGURATION: '/api/configuration',
  CONFIGURATIONS: '/configurations',
  CONFIG: "/config",
  UI_CONFIG: "/ui-config",
  WEB_APP_CONFIG: "/web-app-config",
  UI_CONFIGUTATION: "/configuration",
  CDN: "/cdn",

  MARKETPLACE: '/ms-marketplace',
  GET_USER: '/getUser',
  GET_USER_TOKEN: '/getUserToken',
  GET_LIST_CATALOG: '/catalog/groupings',
  GET_FILTER_OPTIONS: '/getFilterOptions',
  CATALOG_GROUPING: '/catalog/grouping',
  FILTERS: '/filters',
  GET_PRODUCT_ITEMS: '/getProductItems',
  PRODUCT_DETAIL_MARKETPLACE: "/getProductItemDetails",
  GET_SHIPPING_ADDRESS: '/getShippingAddresses',
  CREATE_SHIPPING_ADDRESS: '/addUserAddress',
  UPDATE_SHIPPING_ADDRESS: '/updateUserAddress',
  GET_CART_DETAILS: '/getCartDetails',
  UPDATE_CART_DETAILS: '/updateCartDetails',
  SUBMIT_ORDER: '/submitOrder',
  GET_ORDER_LIST: '/getOrders',
  GET_ORDER: '/getOrder',
  MARK_ORDER_ITEM_RECEIVED: '/markOrderItemReceived',
  DELETE_SHIPPING_ADDRESS: '/deleteUserAddress',
  CLEAR_CART: '/clearCart',
  SERVICE_CATALOG: '/catalog',
  GET_BY_ID: '/getById',
  GET_LOCATION: '/getLocation',
  CART: '/cart',
  CHECKOUT: '/checkout',
  SEARCH_PRODUCTS: '/searchProducts',
  CATALOG_METADATA: '/catalog/metadata',
  CANCEL_ORDER: '/cancelOrder',
  GET_PENDING_APPROVALS: '/getPendingApprovals',
  SUBMIT_ORDER_APPROVALS: '/submitOrderApproval',
  CATEGORY_APPROVAL_POLICY: '/category/approval-policy',
  MANAGERS: '/managers',
  EMPLOYEES: '/employees',
  DEVICES: '/devices',
  PARTNER_COUNTRIES_LIST: '/partner/countries-list',
  GET_ADDRESS_CONFIG: '/getAddressConfig',
  WIDGET_STYLE_PROFILE: '/widget/style-profile',
  GET_VIRTUAL_USER: '/user',
  GET_LIST_VIRTUAL_DESKTOP: '/devices/virtual-desktop',
  GET_FILTER_MY_ORDERS: '/orders/metadata',
  CHECK: '/check',
  TASKS: '/tasks',
  NEW_JOINERS: '/new-joiners',
  OFFBOARDING_BY_MANAGER: '/offboardings-by-manager',
  DELETE_NEW_JOINER: '/api/new-joiner',
  PERSONA_DEFINITIONS: '/persona-definitions',
  GROUPINGS: '/groupings',
  GROUPING: '/grouping',
  METADATA: '/metadata',
  USERS: '/users',
  MAIL_DAY_ONE: '/mail-day-one',
  CHECK_LIST: '/check-list',
  PRIOR_APPROVALS_BY_MANAGER: 'prior-approvals-by-manager',
  GROUP: '/group',
  MEMBER: '/member',
  GET_PICKUP_LOCATION_USER_LOGIN: '/getPickupLocation',
  GET_PICKUP_LOCATIONS: '/getPickupLocations',
  GLOBAL_SEARCH: "/global-search",
  POWER_BI: '/power-bi',
  EMBED_TOKEN: '/embed-token',
  WALK_UP_LOCATION: '/walkupLocations',
  SOFTWARES: '/softwares',
  ENTILE: '/entitle',
  SOFTWARE_SUBCRIPTION: '/software-subscription',
  EMPLOYEES_DEVICES: '/employees/devices',
  RESET_PASSWORD: '/reset-password',
  REMOVAL: '/removal',
  GROUPS: '/groups',
  ELIGIBLE_VIRTUAL_DESKTOPS: '/eligible_virtual_desktops',
  ELIGIBLE_VIRTUAL_APPS: '/eligible_virtual_apps',
  GET_DELEGATION_USER: '/getDelegationUser',
  GET_ALL_APPROVAL: '/getAllApprovals',
  GET_ALL_REQUEST: '/getAllRequests',
  VIRTUAL_APP: 'virtual-application',
  VIRTUAL_DESKTOP: 'virtual-desktop',
  OFFBOARDING: '/offboarding',
  OFFBOARDINGS: '/offboardings',
  TASK_DEFINITIONS: '/task-definitions',
  OFFBOARDINGS_BY_MANAGER: '/offboardings-by-manager',
  ELIGIBLE_FOR_REQUEST: '/eligible-for-request',
  REQUIRED_TASKS: '/required-tasks',
  SERVICE_REQUEST:'/service-request',
  CATALOGS: '/catalogs',
  SETTINGS: '/settings',
  FILE: '/file',
  PC_ACKNOWLEDGE_DEVICE : '/pc-acknowledge-device',
  NO_SCAN_REASON: '/no-scan-reasons',
  RESOURCE: '/resource',
  RELEASE: '/release',
  GET_TABLE_DATA_GENERIC: '/getTableDataGeneric',
  SYS_USER_GROUP: '/sys_user_group',
  ORG: '/org',
};

export const REST_METHOD = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
  PUT: 'PUT',
};
